/**
 * Un-localised path of a player's detail page, keyed on the Twitch login the
 * public API already uses. Pass it to the locale-aware `Link` from
 * `@/i18n/navigation`, which adds the locale prefix.
 */
export function playerDetailHref(twitchLogin: string): string {
  return `/creators/${encodeURIComponent(twitchLogin)}`;
}
